export default function isResponseOk(response: { status: number }): boolean {
  return response.status >= 200 && response.status < 300;
}
